module.exports = __webpack_public_path__ + "static/media/sisef_estudiante.ba085d53.png";